<script setup>
import {Splide, SplideSlide} from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

import Text from '../elements/Text.vue';
import { onBeforeMount, ref, onMounted, computed, defineProps } from "vue";
import {fetchGoogleReviews} from "../../mixins/api";
import Image from '../elements/Image.vue';
import SectionContainer from '../containers/SectionContainer.vue';
import ElementContaier from '../containers/ElementContaier.vue';

const testimonials = ref([]);
const props = defineProps({
    currentStudio: {
        type: Object
    },
});

// Current Studio Id
const studioId = computed(() => {
    return props?.currentStudio?.ID
        ? props?.currentStudio?.ID
        : 0;
});

const getGoogleReviews = (studioId) => {
    fetchGoogleReviews(studioId).then((response) => {
        testimonials.value = response;
    });
};

onBeforeMount(() => {
});
onMounted(() => {
    getGoogleReviews(studioId.value);
});

const sliderOptions = {
    arrowPath: 'M40.9782 16.6354L25.2042 0.861441C24.8137 0.470916 24.1805 0.470916 23.79 0.861441C23.3995 1.25197 23.3995 1.88513 23.79 2.27565L37.8574 16.343L2.41398 16.343C1.8617 16.343 1.41398 16.7907 1.41398 17.343C1.41398 17.8953 1.8617 18.343 2.41398 18.343H37.8564L23.79 32.4094C23.3995 32.8 23.3995 33.4331 23.79 33.8236C24.1805 34.2142 24.8137 34.2142 25.2042 33.8236L40.9525 18.0753C41.1488 17.8927 41.2716 17.6322 41.2716 17.343C41.2716 17.0668 41.1596 16.8168 40.9786 16.6358C40.9784 16.6357 40.9783 16.6356 40.9782 16.6354Z',
    type: 'slide',
    perPage: 1,
    perMove   : 1,
    autoplay: false,
    pagination: false,
    arrows: true,
    padding: '0px',
    focus  : 'center',
    classes: {
		arrows: 'splide__arrows splide-circle-arrows',
        arrow : 'splide__arrow splide-circle-arrow',
		prev  : 'splide__arrow--prev splide-circle-arrow-prev',
		next  : 'splide__arrow--next splide-circle-arrow-next',
    }
};

const setAltImg = (event) => {
    event.target.src = 'https://res.cloudinary.com/ilovekickboxing/image/upload/v1/CMS_Site/review-img.png';
}
</script>

<template>
    <SectionContainer>
        <ElementContaier class="studio-testimonial-slider">
            <Splide 
                :options="sliderOptions"
            >
                <SplideSlide
                    v-for="(testimonial) in testimonials"
                    :key="testimonial.schools_google_reviews_id"
                >
                    <div class="studio-testimonial-box">
                        <div class="studio-testimonial-card">
                            <div class="studio-testimonial-avatar">
                                <Image 
                                    :src="testimonial.author_img_url" 
                                    :text="testimonial.author" 
                                    @error="setAltImg"
                                />
                            </div>
                            <div class="studio-testimonial-content">
                                <div class="studio-testimonial-desc">
                                    {{ testimonial.text }}
                                </div>
                                <div class="studio-testimonial-by">
                                    <Text 
                                        type="H4" 
                                        :text="testimonial.author"
                                    />
                                    <Text
                                            :text="testimonial.location.Name"
                                    />
                                </div>
                            </div>
                        </div>                        
                    </div>
                </SplideSlide>                                    
            </Splide>
        </ElementContaier>
    </SectionContainer>
</template>